import React from 'react';
import { LucideProps } from 'lucide-react';

/**
 * Philippine Peso (₱) Icon Component
 * 
 * Designed in the official Lucide 24x24 vector grid standard with 2px stroke weight.
 * Matches Lucide icon geometry, props, and Tailwind sizing conventions (w-4 h-4, w-5 h-5, etc.).
 */
export const PhilippinePeso: React.FC<LucideProps> = ({
  color = 'currentColor',
  size = 24,
  strokeWidth = 2,
  className = '',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M7 4v16" />
      <path d="M7 4h6a5 5 0 0 1 0 10H7" />
      <path d="M4 8h10" />
      <path d="M4 11h10" />
    </svg>
  );
};

export const PesoIcon = PhilippinePeso;
export default PesoIcon;
